module.exports = __webpack_public_path__ + "img/f11.fdca396f.jpg";